// Swym wishlist button skeleton handler
// Skeleton stays visible until Swym wrapper is fully rendered to prevent layout shift
(() => {
  const components = document.querySelectorAll('add-to-cart-component');

  components.forEach((component) => {
    const skeleton = component.querySelector('.swym-skeleton');
    if (!skeleton) return;

    // Watch for Swym wrapper to appear
    const observer = new MutationObserver(() => {
      const wrapper = component.querySelector('.swym-atw-btn-wrapper');
      const wishlistBtn = component.querySelector('#swym-atw-button-container');

      // Only hide skeleton when wrapper AND wishlist button are both present
      if (wrapper && wishlistBtn) {
        // Double RAF ensures Swym rendering is complete before hiding
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            skeleton.classList.add('swym-hidden');
            observer.disconnect();
          });
        });
      }
    });

    observer.observe(component, {
      childList: true,
      subtree: true,
    });

    // Cleanup after 10 seconds if Swym doesn't load
    setTimeout(() => {
      skeleton.classList.add('swym-hidden');
      observer.disconnect();
    }, 10000);
  });
})();

// PowerReviews PDP skeleton handler
(function () {
  const reviewSnippet = document.getElementById('pr-reviewsnippet');
  if (!reviewSnippet) return;

  const section = reviewSnippet.closest('.shopify-block');
  if (!section) return;

  // Watch for PowerReviews content to be fully mounted
  const observer = new MutationObserver(() => {
    const hasContent = reviewSnippet.querySelector('.pr-review-snippet-container');
    const hasStars = reviewSnippet.querySelector('.pr-snippet-stars');

    if (hasContent && hasStars) {
      // Wait 1 second before transitioning to content
      setTimeout(() => {
        reviewSnippet.classList.add('pr-loaded');
        section.classList.add('pr-loaded');
      }, 1000);
      observer.disconnect();
    }
  });

  observer.observe(reviewSnippet, {
    childList: true,
    subtree: true,
  });

  // Fallback: mark as loaded after 6 seconds
  setTimeout(() => {
    reviewSnippet.classList.add('pr-loaded');
    section.classList.add('pr-loaded');
    observer.disconnect();
  }, 6000);
})();
